import type { VariantProps } from "tailwind-variants";

import type { AcuityStatus } from "@/core/types";
import { Badge2 } from "@/ui2/atoms/Badge";
import type { badgeStyles } from "@/ui2/atoms/Badge";
import { cn } from "@/lib/helpers/cn";

type AcuityStatusBadgeProps = {
  className?: string;
  status: AcuityStatus;
};

export function AcuityStatusBadge({ className, status }: AcuityStatusBadgeProps) {
  const { label, variant: badgeVariant } = ACUITY_STATUS_TO_BADGE[status] || {};

  return (
    <Badge2 className={cn("tw:normal-case", className)} size="sm" variant={badgeVariant}>
      {label}
    </Badge2>
  );
}

type Variant = VariantProps<typeof badgeStyles>["variant"];

const ACUITY_STATUS_TO_BADGE: Record<AcuityStatus, { label: string; variant: Variant }> = {
  APPROVED: {
    label: "Approved",
    variant: "outline-success",
  },
  PENDING: {
    label: "Pending",
    variant: "outline-neutral",
  },
  REJECTED: {
    label: "Rejected",
    variant: "outline-error",
  },
  SYSTEM_ASSIGNED: {
    label: "System Change",
    variant: "neutral",
  },
} as const;
